<div class="fail" *ngIf="flashPaymentService.controller.operationError">
    <div class="action-container">
      <div class="icon-confirmation-container icon-fix error">
        <mat-icon class="fix-mat-icon">error</mat-icon>
      </div>
      <div class="tex-confirmation-message">
        <div class="tex-confirmation-title error">¡Ha ocurrido un error!</div>
        <div class="tex-confirmation-text" [innerHTML]="flashPaymentService.controller.errorMessage">
        </div>
      </div>
    </div>
    <div class="line-decorator"></div>
    <div class="action-container">
      <button class="btn btn-danger action-btn" (click)="flashPaymentService.initData()">
        &nbsp; &nbsp; &nbsp; Volver a intentar &nbsp; &nbsp; &nbsp;
      </button>
    </div>
  </div>
